export enum DOCUMENT_TYPE_CODES {
	GRAD = 'Grades',
	INVC = 'Invoice',
	PGDC = 'Proof of Graduation/Completion',
	PPMT = 'Proof of Payment',
	TBRT = 'Textbook Receipt',
	CORP = 'Correspondence',
	CORR = 'Corrections'
}
